
import { Label } from '../../index'
import "react-datepicker/dist/react-datepicker.css";

import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { makeStyles, TextField } from "@material-ui/core";
import { forwardRef } from "react";


export interface CustomDatePickerProps extends ReactDatePickerProps {
  labelText: string;
  selectedDate?: Date;
  dateFormat?: string;
  IsRequired?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}))

export default function CustomDatePicker(props: CustomDatePickerProps) {
  const classes = useStyles();
  const {
    labelText,
    selectedDate,
    selected,
    isClearable,
    dateFormat,
    IsRequired,
    disabled,
    ...rest
  } = props;

  var tempDateFormat = "dd-MMM-yyyy";
  if (dateFormat) {
    tempDateFormat = dateFormat;
  }

  //@ts-ignore
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <TextField
      onClick={onClick}
      disabled={disabled}
      inputRef={ref}
      value={value}
      placeholder={"Date here..."}
      fullWidth
      variant="outlined"
      size="small">

    </TextField>))

  return (
    <>
      <Label labelText={labelText} IsRequired={IsRequired} />

      <DatePicker
        wrapperClassName={classes.root}
        selected={selectedDate || selected}
        dateFormat={tempDateFormat}
        isClearable={isClearable ?? true}
        disabled={disabled}

        customInput={<ExampleCustomInput />}
        {...rest}
      />
    </>

  )
}

